import {useContext, useCallback, useMemo} from 'react';
import {useDispatch} from 'react-redux';
import {EventCreateContext} from '~/CreateFabricInvitation/routes/EventCreateDesign/EventCreateContext';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {CloseLineIcon} from '~library/svg/CloseLineIcon';
import {useImageReset} from '~/CreateFabricInvitation/components/PhotoEditor/common/useImageReset';
import {MENU_TYPES} from './contants';
import {UPDATE_DESIGN_OPTIONS} from '~/CreateFabricInvitation/reducers/fabricDesign/constants';

type Canvas = {
  discardActiveObject: () => void;
  renderAll: () => void;
};

interface PhotoEditorDrawerHeaderProps {
  activeDesignToolMenu: string;
  setActiveDesignToolMenu: (newDesignToolMenu: string) => void;
  scrollToTop: () => void;
  setShowMenu: (showMenu: boolean) => void;
}

export const PhotoEditorDrawerHeader = ({
  activeDesignToolMenu: activeMenu,
  setActiveDesignToolMenu: setActiveMenu,
  scrollToTop,
  setShowMenu,
}: PhotoEditorDrawerHeaderProps) => {
  const {canvas}: {canvas: Canvas | null} = useContext(EventCreateContext);

  const dispatch = useDispatch();

  const {resetImage} = useImageReset(canvas);

  const handleBackClick = () => {
    setActiveMenu(MENU_TYPES.MAIN);
  };

  const getTitle = useMemo(() => {
    switch (activeMenu) {
      case MENU_TYPES.TRANSFORM:
        return 'TRANSFORM';
      case MENU_TYPES.FILTERS:
        return 'FILTERS';
      default:
        return 'PHOTO EDITOR';
    }
  }, [activeMenu]);

  const handleClose = useCallback(() => {
    scrollToTop();
    setShowMenu(false);
    (canvas as unknown as Canvas).discardActiveObject();
    (canvas as unknown as Canvas).renderAll();
    setActiveMenu(MENU_TYPES.MAIN);
    dispatch({
      type: UPDATE_DESIGN_OPTIONS,
      payload: {editingMobile: false},
    });
  }, [canvas, scrollToTop, setShowMenu, dispatch]);

  if (!canvas) return null;

  return (
    <div className="photo-editor-bottom-sheet__header">
      {activeMenu === MENU_TYPES.MAIN ? (
        <Button
          variant="link"
          size="small"
          onClick={resetImage}
          className="photo-editor-bottom-sheet__reset-button"
          data-qa-id="photo-editor-reset-btn"
        >
          Reset all
        </Button>
      ) : (
        <Button
          variant="link"
          size="small"
          onClick={handleBackClick}
          className="photo-editor-bottom-sheet__back-button"
          data-qa-id="photo-editor-back-btn"
        >
          Back
        </Button>
      )}

      <Typography variant="label2" className="photo-editor-bottom-sheet__title">
        {getTitle}
      </Typography>

      <Button
        variant="unstyled-button"
        className="photo-editor-bottom-sheet__close-button"
        onClick={handleClose}
        data-qa-id="photo-editor-close-btn"
      >
        <CloseLineIcon ratio={0.75} />
      </Button>
    </div>
  );
};
